import { render, staticRenderFns } from "./dy-nav.vue?vue&type=template&id=e983adf4&scoped=true&"
import script from "./dy-nav.vue?vue&type=script&lang=js&"
export * from "./dy-nav.vue?vue&type=script&lang=js&"
import style0 from "./dy-nav.vue?vue&type=style&index=0&id=e983adf4&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e983adf4",
  null
  
)

export default component.exports